module.exports = __webpack_public_path__ + "img/22.4917d867.png";